import { TCategory } from './types';

export const regionPopularCategoriesData: TCategory[] = [
	{
		categoryId: 1,
		categoryName: 'Установка дверей',
		categoryDescription:
			'Установим межкомнатную дверь по фиксированной цене. Гарантия на установку — 1 год.',
		categoryPhotoUrl:
			'/M7oyyXULdkeLpDoAcRhKow/services-platform-regional-landing-ustanovka-dveri.jpg',
		sortOrder: 1,
	},
	{
		categoryId: 2,
		categoryName: 'Установка гардеробных систем',
		categoryDescription:
			'Установим сетчатую гардеробную систему по фиксированной цене. Гарантия на установку — 1 год.',
		categoryPhotoUrl:
			'/05q1mLYEiUWDYoiO6R68Kg/services-platform-regional-landing-ustanovka-garderobnyh-sistem.jpg',
		sortOrder: 2,
	},
	{
		categoryId: 3,
		categoryName: 'Установка кухонь',
		categoryDescription:
			'Установим модульную кухню по фиксированной цене. Гарантия на установку — 1 год.',
		categoryPhotoUrl:
			'/wuPqsmmYbECe2dqjs8UKTA/services-platform-regional-landing-ustanovka-kuhon.jpg',
		sortOrder: 3,
	},
];

export const moscowPopularCategoriesID: number[] = [
	551,
	400,
	342,
	341,
	643,
	576,
	415,
	627,
	578,
	579,
];
